import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "content-feed",
  name: "图文信息流",
  icon: "流",
  group: "信息流页面",
  description: "读取已发布图文，支持列表、瀑布流和规则混排长列表。",
  defaultProps: {
    "title": "推荐图文",
    "layoutMode": "MIXED",
    "pageSize": 20,
    "showPublisher": true,
    "showPublishedAt": true,
    "showSummary": true,
    "showMetrics": true
}
}
